/*
 * Action types for the exam-manager tools (exam.md 1.5 row 1).
 *
 * They live outside Actions/Exam because that module is owned elsewhere; the
 * sagas are registered from Sagas/School/examTools.
 *
 * GET_EXAM_DETAIL hits the SAME route as getExamSingle (`exam/:id`) with the
 * `details=1` flag the exam detail page needs; it is a separate action only
 * because getExamSingle sends no query string, and the extra payload costs
 * two queries per delivery record — which the edit form must not pay.
 *
 * Deliberately absent: the subsection-mark copy reuses RECALCULATE_EXAM_TOTALS
 * from Actions/MultiExam, because it posts to the same (extended)
 * `exam/calculate-total`.
 */
export const GET_EXAM_DETAIL = 'GET_EXAM_DETAIL'
export const COPY_TERM_EXAMS = 'COPY_TERM_EXAMS'
export const GET_UNMARKED_STUDENTS_REPORT = 'GET_UNMARKED_STUDENTS_REPORT'
export const GET_EXAM_DETAIL_REPORT = 'GET_EXAM_DETAIL_REPORT'
